import styled from "styled-components";

export const StatusLabelWrapper = styled.div`

.status_label {
    display: flex;
    align-items: center;
    justify-content: center;
    &_wait {
        background-color: #fb6e2e;
        color: #fff;
        padding: 4px 8px;
        border-radius: 12px;
        cursor: default;
    }
    &_delivering {
        background-color: #fd475a;
        color: #fff;
        padding: 4px 8px;
        border-radius: 12px;
        cursor: default;
    }
    &_delivered{
        background-color: rgb(106, 39, 174);
        color: #fff;
        padding: 4px 8px;
        border-radius: 12px;
        cursor: default;
    }
    &_cancelled{
        background-color: #fbaa08;
        color: #fff;
        padding: 4px 8px;
        border-radius: 12px;
        cursor: default;
    }
    .no-wrap-content{
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        white-space: nowrap;
    }
}

`
